export function About() {
  return (
    <div className="max-w-6xl mx-auto container-px py-14">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        <div>
          <h1 className="text-3xl md:text-4xl display">About Mano Studio</h1>
          <p className="mt-4 text-foreground/80 leading-relaxed">
            Mano Studio is a clay design studio in Bangkok. We make small-batch objects with a calm,
            tactile presence: vessels, tableware, and sculptural forms. Our approach blends
            Scandinavian restraint with the warmth of Thai craft.
          </p>
          <p className="mt-4 text-foreground/80 leading-relaxed">
            We work slowly, with respect for materials and process. Each piece passes through our
            hands from forming to glazing and firing.
          </p>
        </div>
        <div className="rounded-xl overflow-hidden border border-border bg-card">
          <img
            src="https://images.pexels.com/photos/6692153/pexels-photo-6692153.jpeg?auto=compress&cs=tinysrgb&w=1600"
            alt="Studio still life with ceramics"
            className="w-full h-full object-cover"
          />
          <p className="p-3 text-xs text-foreground/70">Photo: Tara Winstead / Pexels</p>
        </div>
      </div>
    </div>
  );
}
